'use client'

import { IS_PROD } from '@/core/constants/is-prod'
import { PROVIDER_ROUTES } from '@/core/constants/routes'
import { envService } from '@/core/services/env'
import { useCookiesStore } from '@/core/store/cookies'
import { usePathname } from '@/i18n/navigation'
import { useEffect } from 'react'
import { analytics } from '../../core/analytics/google-analytics'
import { fbp } from '../../core/analytics/pixel'

export const PageTracking = () => {
  const pathname = usePathname()
  const isProvider = pathname?.includes(PROVIDER_ROUTES.base)
  const gaId = envService.get('GOOGLE_ANALYTICS_ID')
  const pixelId = isProvider
    ? envService.get('PROVIDER_PIXEL_ID')
    : envService.get('CUSTOMER_PIXEL_ID')

  const { cookiesConsented } = useCookiesStore()
  const gaEnabled = gaId && IS_PROD && cookiesConsented
  const piexelEnabled = pixelId && IS_PROD && cookiesConsented

  useEffect(() => {
    if (!gaEnabled) {
      return
    }
    analytics.pageView({
      page_location: pathname,
      page_title: document.title,
    })
  }, [pathname, gaEnabled])

  useEffect(() => {
    if (!piexelEnabled) {
      return
    }
    fbp.pageView()
  }, [pathname, piexelEnabled])

  return null
}
